/**
 * Lite 社群連結（SSOT）
 * 商家名稱旁 icon 用
 */

export const LITE_DISCORD_URL = 'https://discord.gg/gxeRFAYc';

export const LITE_IG_URL = 'https://www.instagram.com/emvyax';

export const LITE_SOCIAL_LINKS = {
  discord: LITE_DISCORD_URL,
  ig: LITE_IG_URL,
} as const;
